import { render, staticRenderFns } from "./CarritoFooter.vue?vue&type=template&id=f19778de&scoped=true&"
import script from "./CarritoFooter.vue?vue&type=script&lang=js&"
export * from "./CarritoFooter.vue?vue&type=script&lang=js&"
import style0 from "./CarritoFooter.vue?vue&type=style&index=0&id=f19778de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19778de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
